import { Box, Typography, useTheme } from "@mui/material";
import { LockOutlined as LockIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { SESSION_STORAGE_KEYS } from "utils/constants";

import { styled } from "@mui/material/styles";

const TitleText = styled(Typography)(({ theme }) => ({
  fontFamily: "ArialMT",
  fontSize: "50px",
  // Note: Accessing sessionStorage inside a style definition can be risky
  // if the value changes after the component mounts.
  color: sessionStorage.getItem(SESSION_STORAGE_KEYS.THEME_COLOR) || theme.palette.primary.main,
  letterSpacing: "1.25px",
  fontWeight: 700,
  textAlign: "center",
  textTransform: "uppercase",
}));

const GreyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  letterSpacing: 0,
  textAlign: "center",
  lineHeight: "39px",
  fontWeight: 400,
}));

const CloseWindowText = styled(GreyText)({
  fontSize: "26px",
  width: "90%",
  // Any styles in GreyText (like color and fontWeight)
  // are inherited and overridden by these properties.
});

export const Unauthorized = (): React.ReactElement => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <LockIcon
        style={{ fontSize: "76px" }}
        htmlColor={
          sessionStorage.getItem(SESSION_STORAGE_KEYS.THEME_COLOR) || theme.palette.primary.main
        }
      />
      <TitleText>{t("not_authorized", "Access Denied")}</TitleText>
      <CloseWindowText>
        {t(
          "not_authorized_dialog",
          "You do not have access this site. If you feel you have received this message in error, please contact the help desk to request the appropriate access.",
        )}
      </CloseWindowText>
    </Box>
  );
};
